<template>
    <div class="tab-content">
        <view-form
            v-if="mountedTabs.view"
            v-show="physician.ViewTab"
            ref="viewForm"
            :documentOptions="documentOptions"
            @documents-loaded="onDocumentsLoaded"
        ></view-form>
        <upload-new-form
            v-if="mountedTabs.upload"
            v-show="physician.UploadTabs"
            :documentOptions="documentOptions"
            @documents-uploaded="onDocumentsUploaded"
        ></upload-new-form>
    </div>
</template>
<script>
    import FormMixin from 'mixins/FormMixin'
    import HandleRequestMixin from 'mixins/HandleRequestMixin'
    import PhysicianMixin from 'mixins/PhysicianMixin'
    import ViewForm from 'components/forms/view-document/ViewForm'
    import UploadNewForm from 'components/forms/upload-new/UploadNewForm'
    import PatientAPI from 'api/PatientAPI'

    export default {
        mixins: [FormMixin, HandleRequestMixin, PhysicianMixin],
        components: {
            ViewForm,
            UploadNewForm,
        },
        props: {
            physician: { type: Object, required: true },
        },

        data() {
            return {
                documentOptions: [],
                documentOptionsLoaded: false,
                documentsNeedRefresh: false,
                mountedTabs: {
                    view: false,
                    upload: false,
                    request: false,
                },
            }
        },

        methods: {
            ensureDocumentTypes() {
                if (this.documentOptionsLoaded) {
                    return
                }
                this.getDocumentType()
            },
            getDocumentType() {
                PatientAPI.getDocumentType().then((res) => {
                    this.documentOptions = res.map((item) => ({
                        label: item.name,
                        value: item.id,
                    }))
                    this.documentOptionsLoaded = true
                })
            },
            onDocumentsLoaded() {
                this.ensureDocumentTypes()
            },
            onDocumentsUploaded() {
                this.documentsNeedRefresh = true
                this.refreshDocuments()
            },
            refreshDocuments() {
                if (!this.$refs.viewForm) {
                    return
                }
                this.$refs.viewForm.offset = 0
                this.$refs.viewForm.documents = []
                this.$refs.viewForm.getDocuments()
                this.documentsNeedRefresh = false
            },
        },

        watch: {
            physician: {
                handler(val) {
                    if (val.ViewTab) {
                        this.mountedTabs.view = true
                        if (this.documentsNeedRefresh) {
                            this.$nextTick(() => this.refreshDocuments())
                        }
                    }
                    if (val.UploadTabs) {
                        this.mountedTabs.upload = true
                        this.ensureDocumentTypes()
                    }
                    if (val.RequestTab) {
                        this.mountedTabs.request = true
                    }
                },
                deep: true,
                immediate: true,
            },
        },
    }
</script>
